import BaseUIComponent from 'ui/baseUIComponent';
import 'css/ui/hitArea.css';

export default class HitArea extends BaseUIComponent {
  constructor (x,y,w,h, handler, context, player) {
    super();

    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
    this.player = player;

    this.touchX = undefined;


    this.element = this._createElement(x,y,w,h);
    this.handler = handler.bind(context);

    this.element.addEventListener('touchstart', (e) => {
      const { pageX, pageY } = e.touches[0];
      this.touchX = pageX;
      this.touchInProgress = true;
    });

    this.element.addEventListener('touchmove', (e) => {
      const { pageX, pageY } = e.touches[0];
      if (pageX < this.x || pageX > this.x + this.w || pageY < this.y || pageY > this.y + this.h) {
        this.touchInProgress = false;
      } else {
        this.touchX = pageX;
      }
    })

    this.element.addEventListener('touchend', (e) => {
      this.touchInProgress = false;
      this.touchX = undefined;
      e.stopPropagation();
      e.preventDefault();
    })
  }

  update () {
    if (this.touchInProgress) {
      this.handler(this.player, this.touchX);
    }
  }

  _createElement (x,y,w,h) {
    const el = document.createElement('div');
    el.innerHTML = '.';
    el.className = 'hitArea';
    el.style.top = y + 'px';
    el.style.left = x + 'px';
    el.style.width = w + 'px';
    el.style.height = h + 'px';
    this.parent.appendChild(el);
    return el;
  }
}



// WEBPACK FOOTER //
// ./src/ui/hitArea.js